import React from 'react';
import { Icon } from 'antd';

function GoogleIconSvg(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 48 48">
      <path
        fill="#FBBC05"
        d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"
      />
      <path
        fill="#EA4335"
        d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"
      />
      <path
        fill="#34A853"
        d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0124 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"
      />
      <path
        fill="#4285F4"
        d="M43.611 20.083L43.595 20H24v8h11.303a12.04 12.04 0 01-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"
      />
    </svg>
  );
}

const outlookSvg = props => (
  <svg {...props} viewBox="0 0 239.82 287.5" width="1em" height="1em">
    <g data-name="Layer 2">
      <path
        d="M239.82 263.54V24.69L154.22 0 .39 57.76l-.39.08v172.69L52.51 210V69.48l101.71-24.32v206.59L.1 230.53l154.11 56.91v.06l85.58-23.69v-.27z"
        fill="#c75b12"
        data-name="Layer 1"
      />
    </g>
  </svg>
);

const GoogleIcon = props => (
  <Icon
    component={GoogleIconSvg}
    style={{ fontSize: '18px', verticalAlign: 'middle', display: 'inline-block' }}
    {...props}
  />
);

const OutlookIcon = props => (
  <Icon
    component={outlookSvg}
    style={{ fontSize: '18px', verticalAlign: 'middle', display: 'inline-block' }}
    {...props}
  />
);

export { GoogleIcon, OutlookIcon };
